import thresholdSchema from './thresholdSchema';
import { units } from '../../../../units';

export const schema = {
  type: 'object',
  properties: {
    title: {
      type: 'string',
      title: 'Title',
    },
    min: {
      type: 'integer',
      title: 'Minimum',
      default: 0,
    },
    max: {
      type: 'integer',
      title: 'Maximum',
      default: 100,
    },
    unit: {
      type: 'string',
      title: 'Unit',
      default: units[0].id,
      anyOf: units.map((unit) => ({
        const: unit.id,
        title: `${unit.category}: ${unit.name}`,
      })),
      description: 'Automatic unit conversion (e.g., kW to MW) is applied to default signal units',
    },
    unitLabel: {
      type: 'string',
      title: 'Custom unit label',
      description: 'This takes precedence over Unit',
    },
    decimals: {
      type: 'string',
      title: 'Decimals',
      default: 'auto',
      enum: ['auto', '0', '1', '2', '3', '4', '5'],
    },
    ...thresholdSchema,
  },
};

export const uiSchema = {
  unit: {
    'ui:field': 'customUnitLabel',
  },
  unitLabel: {
    'ui:field': 'customUnitLabel',
  },
  thresholds: {
    areaItems: {
      'ui:options': {
        orderable: false,
      },
    },
    linearItems: {
      'ui:options': {
        orderable: false,
      },
    },
  },
};
